import { DeletionRequest } from "@switcherstudio/switcher-api-client";
import * as React from "react";
import {
    Button,
    useNotify,
    useRefresh,
    useRecordContext
} from "react-admin";
import { client } from "../../api/client";



/**
 * A button that will cancel the deletion request of a user, effectively deleting them from the database. Calls DELETE api/User/{id}/DeletionRequest
 */
export const CancelDeletionRequestButton: React.FC = () => {
    const notify = useNotify();
    const refresh = useRefresh();
    const record = useRecordContext<DeletionRequest & { id: string }>();
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const cancel = React.useCallback(() => {
        if (!record) {
            notify("No record found", { type: "error" });
            return;
        }
        
        setIsLoading(true);

        // Call the delete endpoint for the deletion request
        return client.deletionRequests_DeleteDeletionRequest(record.id)
        .then(() => {
            setIsLoading(false);
            notify("Deletion request was canceled", { type: "success" });
            refresh();
        })
        .catch(() => {
            setIsLoading(false);
            notify("Unable to cancel deletion request", { type: "error" });
        });
    }, [record, notify, refresh, setIsLoading]);

    return (
        <Button
            label="Cancel"
            onClick={() => cancel()}
            disabled={isLoading}
        />
    );
};
